import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=1c5fbc48"
import script from "./SubscriptionView.vue?vue&type=script&lang=js"
export * from "./SubscriptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c5fbc48')) {
      api.createRecord('1c5fbc48', component.options)
    } else {
      api.reload('1c5fbc48', component.options)
    }
    module.hot.accept("./SubscriptionView.vue?vue&type=template&id=1c5fbc48", function () {
      api.rerender('1c5fbc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/vehiclelookup/SubscriptionView.vue"
export default component.exports